// Based off the W3C specification:
// https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
const VALID_EMAIL_REGEX: RegExp =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

/**
 * Validates an email address, returning true if it is valid and false otherwise.
 */
export function isValidEmailAddress(email: string): boolean {
  if (!email) {
    return false;
  }
  return VALID_EMAIL_REGEX.test(email);
}

/**
 * Normalizes an email address for use as a lookup or de-duplication key.
 *
 * Trimming and lowercasing only — no domain-specific canonicalization (Gmail
 * dot/plus folding and the like), because two addresses that differ that way
 * are two mailboxes as far as every system we hand them to is concerned.
 *
 * This is the single definition on purpose. Contact-list shard assignment,
 * campaign ledger ids, and contact-preference lookups all key off the result;
 * if any of them normalized differently, the same person would land in two
 * buckets and the de-duplication those features exist to provide would
 * silently stop working.
 *
 * @param email - Raw address, possibly with surrounding whitespace or mixed
 *   case. An empty or whitespace-only string normalizes to `''`.
 * @return The normalized address.
 * @throws Never.
 */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

export * from './time';
